import {
  GET_FOLDER_BY_ID_USE_CASE,
  SEARCH_SPACE_OBJECTS_USE_CASE,
  MOVE_FOLDER_PICKER_USE_CASE,
  SPACE_REPOSITORY,
  ISpaceObjectsRepository,
  SearchSpaceObjectsUseCase,
} from '@module/form';
import { LOAD_MORE_SPACE_OBJECTS_USE_CASE } from 'redux/space';

export const spaceObjectsSearchUseCaseProviders: any = [
  {
    provide: SEARCH_SPACE_OBJECTS_USE_CASE,
    useFactory: (spaceObjectsRepository: ISpaceObjectsRepository) => {
      return new SearchSpaceObjectsUseCase(spaceObjectsRepository);
    },
    inject: [SPACE_REPOSITORY],
  },
  {
    provide: GET_FOLDER_BY_ID_USE_CASE,
    useFactory: (spaceObjectsRepository: ISpaceObjectsRepository) => {
      return new SearchSpaceObjectsUseCase(spaceObjectsRepository);
    },
    inject: [SPACE_REPOSITORY],
  },
  {
    provide: MOVE_FOLDER_PICKER_USE_CASE,
    useFactory: (spaceObjectsRepository: ISpaceObjectsRepository) => {
      return new SearchSpaceObjectsUseCase(spaceObjectsRepository);
    },
    inject: [SPACE_REPOSITORY],
  },
  {
    provide: LOAD_MORE_SPACE_OBJECTS_USE_CASE,
    useFactory: (spaceObjectsRepository: ISpaceObjectsRepository) => {
      return new SearchSpaceObjectsUseCase(spaceObjectsRepository);
    },
    inject: [SPACE_REPOSITORY],
  },
];
